import PropTypes from 'prop-types'

const Loader = ({ style = {} }) => {
  return (
    <div
      className="loader"
      style={{
        left: '47.5%',
        top: '30%',
        border: '4px dashed black',
        borderTop: '4px solid $ctp-color__light_brown',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        animation: 'spin 2s linear infinite',
        ...style,
      }}
    />
  )
}

Loader.propTypes = {
  style: PropTypes.object,
}

export default Loader
